module.exports = __webpack_public_path__ + "static/img/wrong-s.fee48d74.svg";